export const getDevicesInfo = async () => {
  const devices = await navigator.mediaDevices.enumerateDevices();

  const audioInputDevices = devices.filter(
    (device) => device.kind === 'audioinput'
  );

  return {
    audioInputDevices,
    hasAudioInputDevices: audioInputDevices.length > 0,
  };
};
